import { toast } from '@systemeio/ui'
import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api'
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export const useScheduleNewsletter = () => {
  const { t } = useLocoTranslation()

  const { fetcher, isFetching } = useFetch({
    method: RequestMethodsEnum.post,
  })
  return {
    fetcherScheduleNewsletter: async (id: NewsletterId, data: { sendAt: string }) => {
      try {
        await fetcher(`${NEWSLETTERS_API}/${id}/preview`, data)
        toast.success(t('dashboard.newsletter_editor.was_scheduled_message'))
      } catch (e) {
        throw e
      }
    },
    isFetchingScheduleNewsletter: isFetching,
  }
}
